import React, { FC } from 'react';
import { Box, Checkbox, Text } from '@bechtel/gds';
import { FieldArray, FieldProps } from 'formik';
import { findIndex, some } from 'lodash';
import { ListSelectionStyled, DrawerSubHeaderStyled } from '@bechtel/client-common';
import { Trans } from '@lingui/macro';
import { weldSizeList } from '../form-state';
import { useLingui } from '@lingui/react';

export const WeldSizeList: FC<FieldProps> = ({ form }) => {
  const { i18n } = useLingui();

  return (
    <Box flexDirection={{ sm: 'column' }} data-testid="weld-size-container">
      <DrawerSubHeaderStyled>
        <Trans>Diameter</Trans>
      </DrawerSubHeaderStyled>
      <FieldArray name="weldSizeList">
        {(arrayHelpers) => {
          return (
            <>
              {weldSizeList.length > 0 &&
                weldSizeList.map((weldSizeItem) => {
                  return (
                    <ListSelectionStyled
                      key={weldSizeItem.id}
                      data-testid={`weld-size-item-${weldSizeItem.id}`}
                      onClick={() => {
                        const selected = findIndex(form.values.weldSizeList, (item) => {
                          return item === weldSizeItem.value;
                        });
                        if (selected !== -1) {
                          arrayHelpers.remove(selected);
                        } else {
                          arrayHelpers.push(weldSizeItem.value);
                        }
                      }}
                    >
                      <Box mr={{ sm: '500' }}>
                        <Checkbox
                          checked={some(form.values.weldSizeList, (item) => {
                            return item === weldSizeItem.value;
                          })}
                          readOnly
                        />
                      </Box>
                      <Text size="400" color="bechtel.grey.1000">
                        {i18n._(weldSizeItem.label)}
                      </Text>
                    </ListSelectionStyled>
                  );
                })}
            </>
          );
        }}
      </FieldArray>
    </Box>
  );
};
